/**
 * Purpose: Setting releated selectors (most likely just dealer settings).
 */

// libraries
import type { OfferReduxBaseState } from '../types/offerReduxBaseState';
import type { OfferType } from '@makemydeal/dr-platform-types';
import { OFFER_TYPE } from '@makemydeal/dr-platform-types';

// utils
import { getSelectedCreditTierIdByType, getVehicleDetails } from './offerNodeSelectors';

export function isLeasingSettingEnabled(state: any) {
    return state.dealer?.shouldIncludeLease || false;
}

export function shouldDisplayLease(state: OfferReduxBaseState) {
    const vehicle = getVehicleDetails(state);
    const vehicleCondition = vehicle.type || vehicle.condition;
    const isLeasingEnabled = isLeasingSettingEnabled(state);
    return vehicleCondition === 'new' && isLeasingEnabled;
}

export function getDealerDefaultTermsByOfferType(state: OfferReduxBaseState, offerType: OfferType) {
    const creditTierId = getSelectedCreditTierIdByType(state, offerType);
    const dealerCreditTiers = state.dealer.creditTiers;
    const creditTierOfferNode = offerType === OFFER_TYPE.finance ? dealerCreditTiers.finance : dealerCreditTiers.lease;
    let dealerCreditTier: any = null;
    creditTierOfferNode.forEach((creditTier: any) => {
        if (creditTier.id === creditTierId) {
            dealerCreditTier = creditTier;
        }
    });
    return dealerCreditTier ? dealerCreditTier.terms : [];
}

export function getDealerCommonOrgId(state: OfferReduxBaseState) {
    return state.dealer?.commonOrgId;
}
